import React, { useEffect, useRef } from "react";
import jsonData from "../JSON Data/industrydata.json";
import { useParams } from "react-router-dom";

function Industries() {
  const { section } = useParams();
  const sectionData = jsonData[section];
  const observedElements = useRef([]);
  const processContent = (content) => {
    const colonIndex = content.indexOf(":");
    if (colonIndex !== -1) {
      const beforeColon = content.substring(0, colonIndex + 1).trim();
      const afterColon = content.substring(colonIndex + 1).trim();
      const wordsCount = beforeColon.split(" ").length;

      if (wordsCount <= 10) {
        return (
          <>
            <strong>{beforeColon}</strong> {afterColon}
          </>
        );
      }
    }
    return content;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.transform = "scale(1)";
            entry.target.style.opacity = "1";
          } else {
            entry.target.style.transform = "scale(0.95)";
            entry.target.style.opacity = "0";
          }
        });
      },
      { threshold: 0.1 }
    );

    observedElements.current.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!sectionData || !sectionData.contents) {
    return <div>Data not found or invalid format</div>;
  }

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  return (
    <>
      <div className="template ">
        <div className="templatebrd industry-brd">
          <h2>{sectionData.breadCrumb}</h2>
          <h1>
            {sectionData.breadCrumb ===
            "INDUSTRIES SERVED / SUCCESS STORIES / CASE STUDIES / TESTIMONIALS"
              ? "SUCCESS STORIES / CASE STUDIES / TESTIMONIALS"
              : sectionData.breadCrumb
                  .split("/")
                  .map((item) => item.trim())
                  .pop()}
          </h1>
        </div>
        <div className="templatecontent">
          {sectionData.contents.map((element, index) => (
            <React.Fragment key={index}>
              {element.tag === "img" ? (
                <img
                  src={element.src}
                  alt={element.alt || ""}
                  ref={(el) => {
                    if (el) {
                      observedElements.current.push(el);
                    }
                  }}
                />
              ) : element.tag === "ul" ? (
                <ul>
                  {element["list-items"].map((item, i) => (
                    <li key={i}>{processContent(item)}</li>
                  ))}
                </ul>
              ) : element.tag === "ol" ? (
                <ol>
                  {element["list-items"].map((item, i) => (
                    <li key={i}>{processContent(item)}</li>
                  ))}
                </ol>
              ) : (
                React.createElement(
                  element.tag,
                  {
                    key: index,
                    ref: (el) => {
                      if (el) {
                        observedElements.current.push(el);
                      }
                    },
                  },
                  processContent(element.content)
                )
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}

export default Industries;
